export default __webpack_public_path__ + "static/media/default-violet-avatar.87b147bd.png";